import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

const Footer = () => {

  const location = useLocation();
  const navigate = useNavigate()
  const baseUrl = window.location.origin
  const baseCandidateUrl = process.env.REACT_APP_CANDIDATE_URL
  const baseBusinessURl=process.env.REACT_APP_BUSINESS_URL

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }

  
  return (
    <footer className="footer">
      <div className='footer-social-icon-container'>
        <span className="footer-social-icon-text">
          Connect with Us
        </span>
        <ul className="footer-socials-icon-image">
          <li>
            <a href="/" className="footer-social-link-image">
              <svg className="footer-social-icon" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" />
              </svg>
            </a>
          </li>
          <li>
            <a
              href="https://www.youtube.com/@1800HIRED"
              className="footer-social-link-image"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg
                className="footer-social-icon"
                fill="currentColor"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path d="M23.498 6.186a2.965 2.965 0 00-2.084-2.097C19.483 3.5 12 3.5 12 3.5s-7.483 0-9.414.589A2.965 2.965 0 00.502 6.186 31.86 31.86 0 000 12a31.86 31.86 0 00.502 5.814 2.965 2.965 0 002.084 2.097C4.517 20.5 12 20.5 12 20.5s7.483 0 9.414-.589a2.965 2.965 0 002.084-2.097A31.86 31.86 0 0024 12a31.86 31.86 0 00-.502-5.814zM9.75 15.02V8.98l6.25 3.02-6.25 3.02z" />
              </svg>
            </a>
          </li>
          {/* <li>
            <a href="/" className="footer-social-link-image">
              <svg className="footer-social-icon" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
              </svg>
            </a>
          </li>
          <li>
            <a href="/" className="footer-social-link-image">
              <svg className="footer-social-icon" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path fillRule="evenodd" d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z" clipRule="evenodd" />
              </svg>
            </a>
          </li> */}
          <li>
            <a href="https://www.linkedin.com/company/1-800-hired" target="_blank" rel="noopener noreferrer" className="footer-social-link-image">
              <svg className="footer-social-icon" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M19 0h-14c-2.76 0-5 2.24-5 5v14c0 2.76 2.24 5 5 
               5h14c2.76 0 5-2.24 5-5v-14c0-2.76-2.24-5-5-5zm-11 
               19h-3v-10h3v10zm-1.5-11.3c-.97 0-1.75-.79-1.75-1.75s.79-1.75 
               1.75-1.75 1.75.79 1.75 1.75-.78 1.75-1.75 
               1.75zm13.5 11.3h-3v-5.6c0-1.34-.03-3.06-1.87-3.06-1.87 
               0-2.16 1.46-2.16 2.96v5.7h-3v-10h2.88v1.37h.04c.4-.75 
               1.38-1.54 2.84-1.54 3.04 0 3.6 2 3.6 
               4.59v5.58z"/>
              </svg>
            </a>
          </li>
        </ul>
      </div>
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-column">
            <h3 className="footer-title">Platform</h3>
            <ul className="footer-list">
              <li className="footer-list-item">
                <a href="/" className="footer-link">The all-together hiring
                  platform</a>
              </li>
              <li className="footer-list-item">
                <a href="/" className="footer-link">Latest product features</a>
              </li>
              {/* <li className="footer-list-item">
                <a href="/" className="footer-link">Pricing</a>
              </li>
              <li className="footer-list-item">
                <a href="/" className="footer-link">Security</a>
              </li>
              <li className="footer-list-item">
                <a href="/" className="footer-link">Ethical principles</a>
              </li> */}
            </ul>
          </div>
          <div className="footer-column">
            <h3 className="footer-title">Why 1800hired</h3>
            <ul className="footer-list">
              <li className="footer-list-item">
                <a href="/" className="footer-link">How we compare</a>
              </li>
              <li className="footer-list-item">
                <a
                  href="/pages/coming-soon"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToTop()
                    navigate("/pages/coming-soon");
                  }}
                  className="footer-link"
                >Return on your hiring
                  investment</a>
              </li>
              <li className="footer-list-item">
                <a
                  href="/pages/coming-soon"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToTop()
                    navigate("/pages/coming-soon");
                  }}
                  className="footer-link"
                >Your partner in success</a>
              </li>
            </ul>
          </div>
          <div className="footer-column">
            <h3 className="footer-title">About</h3>
            <ul className="footer-list">
              <li className="footer-list-item">
                <a
                  href="/pages/about-us"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToTop()
                    navigate("/pages/about-us");
                  }}
                  className="footer-link"
                >
                  Company</a>
              </li>
              <li className="footer-list-item">
                <a
                  href="/pages/coming-soon"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToTop()
                    navigate("/pages/coming-soon");
                  }}
                  className="footer-link"
                >Press & awards</a>
              </li>
              <li className="footer-list-item">
                <a
                  href="/pages/coming-soon"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToTop()
                    navigate("/pages/coming-soon");
                  }}
                  className="footer-link"
                >Careers</a>
              </li>
              <li className="footer-list-item">
                <a
                  href="/pages/contact-us"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToTop()
                    navigate("/pages/contact-us");
                  }}
                  className="footer-link"
                >  Contact
                </a>
              </li>
            </ul>
          </div>
          <div className="footer-column">
            <h3 className="footer-title">Solutions</h3>
            <ul className="footer-list">
              <li className="footer-list-item">
                <a
                  href="/pages/coming-soon"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToTop()
                    navigate("/pages/coming-soon");
                  }}
                  className="footer-link"
                >
                  Onboarding</a>
              </li>
              <li className="footer-list-item">
                <a href="/" className="footer-link" onClick={() => window.open(`${baseUrl}/register`, "_blank")}>For Recruiters</a>
              </li>
              <li className="footer-list-item">
                <a href="/" className="footer-link" onClick={() => window.open(`${baseBusinessURl}`, "_blank")}>For Businesses</a>
              </li>
              <li className="footer-list-item">
                <a href="/" className="footer-link"  onClick={() => window.open(`${baseCandidateUrl}`, "_blank")}>For Candidates</a>
              </li>
            </ul>
          </div>
          {/* <div className="footer-column">
            <h3 className="footer-title">DOWNLOAD</h3>
            <ul className="footer-list">
            <li className="footer-list-item">
                <a
                  href="/pages/coming-soon"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToTop();
                    navigate("/pages/coming-soon");
                  }}
                  className="footer-link"
                >
                  iOS
                </a>
              </li>
              <li className="footer-list-item">
                <a
                  href="/pages/coming-soon"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToTop();
                    navigate("/pages/coming-soon");
                  }}
                  className="footer-link"
                >
                 Andorid
                </a>
              </li>
              <li className="footer-list-item">
                <a
                  href="/pages/coming-soon"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToTop()
                    navigate("/pages/coming-soon");
                  }}
                  className="footer-link"
                >
                 Windows
                </a>
              </li>
              <li className="footer-list-item">
                <a
                  href="/pages/coming-soon"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToTop()
                    navigate("/pages/coming-soon");
                  }}
                  className="footer-link"
                >
                  MacOS
                </a>
              </li>
            </ul>
          </div> */}
        </div>
        <div className="footer-bottom">
          <span className="footer-copy">
            ©2025 1800hired.com
          </span>
          <ul className="footer-socials">
            <li>
              <a
                href="/pages/privacy-policy"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToTop()
                  navigate("/pages/privacy-policy");
                }}
                className="footer-social-link"
              >Privacy Policy</a>
            </li>
            <li>
              <a
                href="/pages/terms-of-service"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToTop()
                  navigate("/pages/terms-of-service");
                }}
                className="footer-social-link"
              >Terms & conditions</a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  )
}

export default Footer